// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResizeObserver$Showside from "../../utils/ResizeObserver.bs.js";
var emptyPositions = {
  modalTop: 0,
  modalMaxHeight: 0,
  siteHeaderSize: ResizeObserver$Showside.empty
};
var emptyCtx_currentFullPath = [];
var emptyCtx = {
  mode: /* Topbar */0,
  currentFullPath: emptyCtx_currentFullPath,
  currentL1: undefined,
  currentL2: undefined,
  currentL3: undefined,
  pageFlipTransitionSpeedMs: 250,
  modalTransitionSpeedMs: 150,
  modalBackdropHeight: 50,
  modalBackdropOpacity: 0.5,
  modalMaxWidth: 480,
  zIndex: 0,
  maxLevels: 4,
  positions: emptyPositions,
  threeColumnLayout: false,
  isModalOpen: false,
  isIndexAllowed: false
};
export { emptyPositions, emptyCtx };
/* ResizeObserver-Showside Not a pure module */